import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Blog.css';

const Blog = () => {
  const articles = [
    {
      title: "Beginner's Guide to Yoga",
      category: 'Yoga Basics',
      readTime: '5 min read',
      desc: 'Start your yoga journey with simple poses and mindful breathing techniques.',
      img: 'https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Morning Meditation Routine',
      category: 'Meditation',
      readTime: '4 min read',
      desc: 'Create a peaceful morning routine that improves focus and reduces stress.',
      img: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&q=80&w=600'
    },
    {
      title: 'Healthy Living Through Yoga',
      category: 'Wellness',
      readTime: '6 min read',
      desc: 'Discover how regular yoga practice supports physical and mental well-being.',
      img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=600'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="blog">
      <div className="blog-container">
        
        <motion.div 
          className="blog-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="blog-subtitle">LATEST ARTICLES</h4>
          <h2 className="blog-title">Wellness Tips & Yoga Insights</h2>
          <p className="blog-desc">
            Simple articles to support your journey toward a healthier and more mindful lifestyle.
          </p>
          <div className="blog-divider"></div>
        </motion.div>

        <motion.div 
          className="blog-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {articles.map((article, idx) => (
             <motion.article key={idx} className="blog-card" variants={itemVariants}>
                <div className="blog-img-wrapper">
                  <img src={article.img} alt={article.title} className="blog-img" />
                </div>
                
                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-category">{article.category}</span>
                    <span className="blog-readtime">• {article.readTime}</span>
                  </div>
                  
                  <h3 className="blog-card-title">{article.title}</h3>
                  <p className="blog-card-desc">{article.desc}</p>
                  
                  <Link to="/blog" className="blog-link">
                    <span>Read More</span>
                    <span className="arrow">→</span>
                  </Link>
                </div>
             </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Blog;
